<template>

  <q-footer
    id="footer"
    class="page-footer">

    <page-block
      bg-color="#292633"
      overlay-class="page-footer__wrapper">

      <!-- Subscribe -->
      <page-subscription
        class="q-mb-lg"/>

      <!-- Menu -->
      <div
        class="page-footer__menu ibs-mb xs-hide">

        <universal-link
          :key="index"
          :to="item.link"
          class="q-mx-xs"
          :class="item.class"
          :target="item.target"
          v-for="(item, index) in menuItems">

          <q-btn
            flat
            no-caps
            :label="item.title.ru"/>

        </universal-link>

      </div>

      <!-- Content -->
      <div
        class="column row-sm q-col-gutter-lg items-sm-start items-center bs-mb">

        <!-- Logo -->
        <div
          class="row q-col-gutter-md items-center justify-center">

          <div>

            <img
              height="65px"
              src="/images/logo/logo-dark-dense.svg"/>

          </div>

          <div
            class="xs-hide">

            <img
              height="50px"
              src="/images/logo/logo-dark-text.svg"/>

          </div>

        </div>

        <!-- Contacts -->
        <div
          class="flex column justify-center no-shrink text-no-wrap">

          <a
            href="phone:+74959579977"
            class="text-h3 text-bold q-mb-none">
            +7 (495) 957-99-77
          </a>

          <a
            href="mailto:info@mos-tender.com"
            class="text-h6 text-bold q-mb-none ghost">
            info@mos-tender.com
          </a>

          <a
            href="mailto:pr-tender@mos.ru"
            class="text-h6 text-bold q-my-none ghost">
            pr-tender@mos.ru
          </a>

        </div>

        <q-space/>

        <!-- Social -->

        <page-footer-social/>

      </div>

      <div
        class="page-footer__copyrights ghost">
        © 2018-{{ new Date().getFullYear() }} Департамент города Москвы по конкурентной политике
      </div>

    </page-block>

  </q-footer>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageSubscription from '@src/components/page/page-subscription';
  import PageFooterSocial from '@src/components/page/page-footer-social';

  export default {
    name: 'page-footer',
    props: {
      menuItems: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      PageBlock,
      PageSubscription,
      PageFooterSocial,
    },
  };

</script>

<style lang="scss">

  $logo-offset: 4.5rem;

  .page-footer {

    a {
      color: inherit;
    }

    &__menu {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      max-height: 3.1rem;
      justify-content: center;

      .q-btn {
        font-weight: normal;
      }
    }

    .ghost {
      opacity: .5;
    }

    &__copyrights {
      text-align: right;

      @media (max-width: $breakpoint-xs) {
        text-align: center;
      }
    }
  }

</style>
